import { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { Section } from 'chaoskit/src/components'

import { sectionSeparator } from '~styles/utility'

export const ProductExpand = (props) => {
  const theme = useTheme()

  return (
    <div
      css={{
        width: '100vw',
        position: 'relative',
        left: '50%',
        right: '50%',
        margin: '0 -50vw',
        paddingLeft: theme.space.base,
        paddingRight: theme.space.base,
        textAlign: 'center',
        overflow: 'hidden',
      }}
      {...props}
    />
  )
}

export const ProductSection = forwardRef(({ separator, ...rest }, ref) => {
  const theme = useTheme()

  return (
    <Section
      space="xlarge"
      css={[
        separator &&
          sectionSeparator(theme, {
            start: theme.brand.blue,
            stop: theme.brand.purple,
          }),
      ]}
      ref={ref}
      {...rest}
    />
  )
})

ProductSection.propTypes = {
  separator: PropTypes.bool,
}

export const ProductGridBlock = ({ size, ...rest }) => {
  const theme = useTheme()

  return (
    <div
      css={[
        {
          display: 'grid',
          gap: theme.space.base,
          alignItems: 'center',

          [theme.mq.medium]: {
            gap: theme.space[size],
            gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
          },
        },
      ]}
      {...rest}
    />
  )
}

ProductGridBlock.propTypes = {
  size: PropTypes.oneOf(['base', 'large']),
}

export const ProductGridBlockContent = (props) => {
  const theme = useTheme()

  return (
    <div
      css={{
        [theme.mq.medium]: {
          gridColumn: '7 / span 6',
          gridRow: 1,
        },
      }}
      {...props}
    />
  )
}
